import { render, staticRenderFns } from "./MonthlyAttendanceList.vue?vue&type=template&id=a65c9f70"
import script from "../../../controllers/student/monthly_attendance/monthly-attendance-list.js?vue&type=script&lang=js&external"
export * from "../../../controllers/student/monthly_attendance/monthly-attendance-list.js?vue&type=script&lang=js&external"
import style0 from "./MonthlyAttendanceList.vue?vue&type=style&index=0&id=a65c9f70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports